import { call, put, takeLatest } from 'redux-saga/effects';
import { captureException } from '@sentry/react';
import { getWLCompanyDataAPI } from '../api/whitelabel.api';
import { progressStart, progressStop } from '../actions';
import ActionTypes from '../constants/ActionTypes';
import { DEFAULT_CONFIG } from '../constants/PlatformConstants';
import { whiteLabelEnabled } from '../constants/AppConstants';

function* getWLCompanyData() {
  const config = structuredClone(DEFAULT_CONFIG);
  try {
    yield put(progressStart());
    if (whiteLabelEnabled) {
      const resp = yield call(getWLCompanyDataAPI);
      config.faviconUrl =
        resp.data.favicon_icon_url ?? DEFAULT_CONFIG.faviconUrl;
      config.companyLogo =
        resp.data.logo_full_icon_url ?? DEFAULT_CONFIG.companyLogo;
      config.companyDarkLogo =
        resp.data.logo_full_icon_url ?? DEFAULT_CONFIG.companyDarkLogo;
      config.company64x64LOGO =
        resp.data.logo_64X64_icon_url ?? DEFAULT_CONFIG.company64x64LOGO;
      config.companyLogoStyle = resp.data.logo_full_icon_url
        ? {
            marginTop: '-7px',
            height: '56px',
          }
        : DEFAULT_CONFIG.companyLogoStyle;
      config.companySupportEmail =
        resp.data.extra_data.white_label_support_email ??
        DEFAULT_CONFIG.companySupportEmail;
    }
  } catch (error) {
    captureException(error);
  } finally {
    yield put({
      type: `${ActionTypes.GET_WHITELABEL_COMPANY_DATA}_SUCCESS`,
      payload: {
        ...config,
        wlCompanyAPICompleted: true,
      },
    });
    yield put(progressStop());
  }
}

export default function* loadWhitelabelSaga() {
  yield takeLatest(ActionTypes.GET_WHITELABEL_COMPANY_DATA, getWLCompanyData);
}
